import { fetchApi } from "./base";

export async function getUserCount() {
  return fetchApi<{ count: number }>("/api/users/count", {
    method: "GET",
  });
}
